import { BOTTOM_NAVIGATION_Z_INDEX } from '@/components/content/Header/constants';
import { SxProps, Theme } from '@mui/material';

export const headerFooterContainerSX = (theme: Theme): SxProps<Theme> => ({
	display: 'flex',
	justifyContent: 'center',
	borderRadius: '0',
	bottom: '0',
	left: '0',
	width: '100vw',
	height: '60px',
	padding: '10px',
	borderTop: '1px solid',
	borderColor: 'grey.50',
	position: 'fixed',
	zIndex: BOTTOM_NAVIGATION_Z_INDEX,
	overflow: 'visible',

	[theme.breakpoints.up('lg')]: {
		display: 'none',
	},
	[theme.breakpoints.down('md')]: {
		display: 'flex',
	},
	[theme.breakpoints.down('sm')]: {
		paddingLeft: '0',
		paddingRight: '0',
	},
});

export const headerFooterEspotContainerSX: SxProps = {
	'@media screen and (max-width: 600px)': {
		maxWidth: '60px',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
};

export const headerButtonsContainerSX = (theme: Theme): SxProps<Theme> => ({
	width: '100%',
	[theme.breakpoints.up('xs')]: {
		paddingLeft: '15px',
		paddingRight: '15px',
	},
});

export const emarketingSpotMenuDrawerSX: SxProps = {
	'& .MuiPaper-root': {
		maxHeight: '80vh',
		bottom: '60px',
	},
};

export const emarketingSpotMenuDrawerTitleSX: SxProps = {
	px: '10px',
	pt: '10px',
	pb: '15px',
};

export const emarketingSpotMenuDrawerContentSX: SxProps = {
	px: '10px',
	pb: '5px',
};
